import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  Select,
  Flex,
  Box,
  Badge,
  Icon,
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';

const Deletestatus = ({
  isOpen,
  onClose,
  selectedstatus,
  projectId,
  statusList,
  listBoardStatus,
  tasks,
}) => {
  const [moveTo, setMoveTo] = useState(null);

  const handleDeleteColumn = async () => {
    const taskIds = (tasks[selectedstatus?.colKey] || []).map(
      (task) => task.id,
    );

    try {
      // Base request body
      const reqBody = {
        project_id: projectId,
        delete_id: selectedstatus?.id,
      };

      // Only include task_ids and new_status_id if taskIds exist
      if (taskIds.length > 0) {
        reqBody.task_ids = taskIds;
        reqBody.new_status_id = moveTo;
      }

      const response = await httpInjectorService.delete_status_column(reqBody);

      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        listBoardStatus();
        onClose();
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      throw error;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent maxW="700px" w="700px">
        {/* Header */}
        <ModalHeader>
          <Flex align="center" gap={2}>
            <Icon as={WarningIcon} color="red.500" />
            <Text fontWeight="bold">
              Move work from {selectedstatus?.colKey} column
            </Text>
          </Flex>
        </ModalHeader>

      
        <ModalCloseButton />

        {/* Body */}
        <ModalBody>
          <Text mb={4}>
            Select a new home for any work with the {selectedstatus?.colKey}{' '}
            status, including work in the backlog.
          </Text>

          <Flex justify="space-between" align="center">
            <Box>
              <Text fontSize="sm" mb={2}>
                This status will be deleted:
              </Text>
              <Badge colorScheme="blue" px={2} py={1}>
                {selectedstatus?.colKey}
              </Badge>
            </Box>

            <Box textAlign="center">
              <Text fontSize="sm" mb={2}>
                Move existing work items to:
              </Text>
              <Select
                placeholder="Select status"
                value={moveTo ?? ''}
                onChange={(e) =>
                  setMoveTo(e.target.value === 'null' ? null : e.target.value)
                }
                w="200px"
              >
                {statusList?.map((status) => (
                  <option key={status.id} value={status.id}>
                    {status.status_name}
                  </option>
                ))}
              </Select>
            </Box>
          </Flex>
        </ModalBody>

        {/* Footer */}
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={handleDeleteColumn}>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default Deletestatus;
